// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__AZPBl","icon":"index_icon__USK+y"};